import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { accountModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { Subscription, Observable, timer } from 'rxjs';
import { LoginService } from './login.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AbpModule } from 'abp-ng2-module';
import { UtilsModule } from '@shared/utils/utils.module';
import { NgOtpInputModule } from 'ng-otp-input';

@Component({
    selector: 'validate-two-factor-code',
    templateUrl: './validate-two-factor-code.component.html',
    styleUrls: ['./validate-two-factor-code.component.less'],
    animations: [accountModuleAnimation()],
    standalone: true,
    imports: [FormsModule, NgbModule, UtilsModule, AbpModule, CommonModule, NgOtpInputModule, RouterModule]
})
export class ValidateTwoFactorCodeComponent extends AppComponentBase implements OnInit, OnDestroy {

    code: string;
    submitting = false;
    remainingSeconds = 90;
    timerSubscription: Subscription;
    @Input() isPopup: boolean = false;
    @Input() isWebFacing: boolean = false;
    @Output() stepUpdate: EventEmitter<number> = new EventEmitter<number>()

    constructor(
        injector: Injector,
        public loginService: LoginService,
        private _router: Router
    ) {
        super(injector);
    }

    canActivate(): boolean {
        if (this.loginService.authenticateModel &&
            this.loginService.authenticateResult
        ) {
            return true;
        }

        return false;
    }

    ngOnInit(): void {
        const timerSource = timer(1000, 1000);
        this.timerSubscription = timerSource.subscribe(() => {
            this.remainingSeconds = this.remainingSeconds - 1;
            if (this.remainingSeconds <= 0) {
                this.message.warn(this.l('TimeoutPleaseTryAgain')).done(() => {
                    this.loginService.authenticateModel.twoFactorVerificationCode = null;
                    if (this.isPopup) {
                        if (this.stepUpdate)
                            this.stepUpdate.emit(1); // Emit an event to update the step in the parent component
                    }
                    else
                        this._router.navigate(['account/login']);
                });
            }
        });
    }

    ngOnDestroy(): void {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
            this.timerSubscription = null;
        }
    }

    submit(): void {
        this.loginService.authenticateModel.twoFactorVerificationCode = this.code;
        this.loginService.authenticate(undefined, undefined, false, this.isPopup);
    }

    returnToLogin(): void {
        if (this.isPopup) {
            if (this.stepUpdate)
                this.stepUpdate.emit(1); // Emit an event to update the step in the parent component
        }
        else
            this._router.navigate(['/login']);
    }
}
